import type { NavBarExtension } from '@pflegenavi/frontend/layout';
import { useFeatureFlag } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag, FeatureFlagStatus } from '@pflegenavi/shared/api';
import { useEmployeeIsNursingHomeAdminOrManager } from '@pflegenavi/frontend/nursing-home-context';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { SvgIconStyle } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';

import bankIcon from './assets/bankIcon.svg';

export const useExpenseManagementNavConfig: () => NavBarExtension = () => {
  const expenseManagementEnabled =
    useFeatureFlag(FeatureFlag.ExpenseManagement) === FeatureFlagStatus.Enabled;

  const isAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();

  const { t } = useTranslation();

  if (!expenseManagementEnabled || !isAdminOrManager) {
    return undefined;
  }

  return {
    item: {
      icon: (
        <SvgIconStyle
          src={bankIcon}
          sx={{
            width: 1,
            height: 1,
          }}
        />
      ),
      title: t('accounting.expenses.page-title'),
      path: nhAppMainPages.EXPENSE_MANAGEMENT_OPEN,
      children: [
        {
          title: t('accounting.expenses.tabs.open'),
          path: nhAppMainPages.EXPENSE_MANAGEMENT_OPEN,
        },
        {
          title: t('accounting.expenses.tabs.scheduled'),
          path: nhAppMainPages.EXPENSE_MANAGEMENT_SCHEDULED,
        },
        {
          title: t('accounting.expenses.tabs.exported'),
          path: nhAppMainPages.EXPENSE_MANAGEMENT_EXPORTED,
        },
      ],
    },
  };
};
